export const PastAnalyses = {
  PastAnalyses: {
    Data: {}
  }
}
